/** DocAISlot — wraps DocAIPanel + the field-mapping logic.
 *  Extracted verbatim from DocsTab.jsx. */
import { toast } from "sonner";
import DocAIPanel from "@/components/DocAIPanel";

const DOC_AI_FIELD_MAP = {
  po_number:        "po_number",
  invoice_number:   "invoice_number",
  manifest_number:  "manifest_number",
  sender_name:      "sender_name",
  receiver_name:    "receiver_name",
  goods_description:"goods_description",
  quantity:         "quantity",
  weight_kg:        "weight",
  volume_m3:        "volume",
};

export default function DocAISlot({ setValues }) {
  return (
    <DocAIPanel
      onParsed={(extracted, fileName) => {
        setValues((vs) => {
          const next = { ...vs };
          for (const [src, dst] of Object.entries(DOC_AI_FIELD_MAP)) {
            const v = extracted?.[src];
            if (v !== undefined && v !== null && v !== "" && (next[dst] === "" || next[dst] == null)) {
              next[dst] = v;
            }
          }
          return next;
        });
        toast.success(`Parsed ${fileName} · confidence: ${extracted?.confidence || "unknown"}`);
      }}
    />
  );
}
